import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ContextService, environment, Role, RoleService } from '@perval/shared';
import { Subject, takeUntil, tap } from 'rxjs';
import { CognitoService } from '../../../../authentification/services/cognito/cognito.service';
import { DrupalService } from '../../../../authentification/services/drupal/drupal.service';
import { Utilisateur } from '../../../../utilisateur/models/utilisateur';
import { UtilisateurService } from '../../../../utilisateur/services/utilisateur.service';
import {
  SharedStateLegacyService,
  StateKey,
} from '../../../services/stockage/shared-state-legacy.service';
import { HeaderService } from './p-header.service';

@Component({
  selector: 'p-header',
  templateUrl: './p-header.component.html',
  styleUrls: ['./p-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PHeaderComponent implements OnInit, OnDestroy {
  @Input() isUserInfoDisplayed = false;

  isUserAuthenticated = false;
  roles: Role[] = [];
  currentUser!: Utilisateur;
  solde: number | undefined;
  currentCrpcen: string | undefined;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly cognitoService: CognitoService,
    private readonly utilisateurService: UtilisateurService,
    private readonly headerService: HeaderService,
    private readonly drupalService: DrupalService,
    private readonly sharedStateLegacyService: SharedStateLegacyService,
    private readonly contextService: ContextService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly roleService: RoleService,
  ) {}

  ngOnInit(): void {
    this.init();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private async init() {
    this.isUserAuthenticated = await this.cognitoService.isAuthenticated();

    if (
      this.isUserAuthenticated &&
      this.drupalService.isSessionDrupalExists()
    ) {
      await this.setCurrentUser();
      this.currentCrpcen = this.contextService.getContext()?.crpcen;

      this.sharedStateLegacyService
        .getStateObservable(StateKey.solde)
        .pipe(
          tap(() => this.changeDetectorRef.markForCheck()),
          takeUntil(this.destroy$),
        )
        .subscribe((solde) => {
          if (solde) {
            this.solde = solde as unknown as number;
          }
        });
    }

    this.headerService
      .getHeaderState()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.setCurrentUser();
      });
  }

  public async signOut(): Promise<void> {
    // La deconnexion est déléguée à Drupal pour que le cookie de session soit supprimé
    // Drupal redirige vers la page de déconnexion de la V2.
    // Cest gérer dans le module createSession --> hook logout.
    window.location.href = `${environment.host}/user/logout`;
  }

  private async setCurrentUser(): Promise<void> {
    const currentLogin = await this.cognitoService.getCurrentLogin();
    if (currentLogin) {
      this.currentUser =
        await this.utilisateurService.getUtilisateurByLogin(currentLogin);
    }
    this.roles = this.roleService.currentUserRoles;
    this.changeDetectorRef.markForCheck();
  }
}
